<script setup lang="ts">
import type {Source} from "@/domain/type/source.type.ts";

const props = defineProps<{
  srcRight: Source,
}>();

function onClick() {
  // todo
}

function text() {
  return 'Dédoublonner';
}
</script>

<template>
  <v-btn :text="text()" style="width:180px;" @click="onClick" disabled/>
</template>

<style scoped>

</style>
